<ng-content select="[app-footer-links]"></ng-content>

<ng-content select="[app-footer-disclaimer]"></ng-content>

<ng-content select="[app-footer-copyright]"></ng-content>
